import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    private messageSubject = new Subject<{ action: string, data: any }>();

    public message$ = this.messageSubject.asObservable();

    sendMessage(action: MessageAction, data: any) {
        this.messageSubject.next({ action, data });
    }
}

export enum MessageAction {
    TURN_ON_PROXY = 'turnOnProxy',
    TURN_OFF_PROXY = 'turnOffProxy',
}
